















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { UniqueSellingPointItemViewModel } from '@/types/contentServerContract';

@Component
export default class UniqueSellingPointItem extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: UniqueSellingPointItemViewModel;

    @Prop()
    textStyle!: Partial<CSSStyleDeclaration>;

    get iconUrl() {
        return this.content.icon?.url;
    }

    get headline() {
        return this.content?.headline;
    }

    get text() {
        return this.content?.shortText;
    }

    get linkUrl() {
        return this.content.link?.url;
    }

    get linkTarget() {
        return this.content.link?.target;
    }

    get linkName() {
        return this.content.link?.name;
    }

    get isPixelImage() {
        return this.iconUrl.indexOf('.jpg') !== -1 || this.iconUrl.indexOf('.jpeg') !== -1 || this.iconUrl.indexOf('.png') !== -1;
    }

    get width() {
        return this.isPixelImage ? 80 : 40;
    }

    get height() {
        return this.isPixelImage ? 80 : 40;
    }

    isColorDefined(color: string): boolean {
        return color?.length === 7 ?? false; // #233445
    }

    backgroundColorStyle(backgroundColor: string): object {
        let result = '';

        if (this.isColorDefined(backgroundColor)) {
            result = backgroundColor;
        }

        return ({
            backgroundColor: result
        });
    }
}

